'use strict'

import React from 'react'
import PropTypes from 'prop-types'

import { ChevronIcon } from '@boltui/icons'

import HelpLink from '../HelpLink/HelpLink'

import './Sidebar.scss'

export default class SideBar extends React.Component {
  static propTypes = {
    links: PropTypes.array,
    activePage: PropTypes.string,
    sticky: PropTypes.bool
  }

  static defaultProps = {
    links: [],
    activePage: '',
    sticky: false
  }

  constructor () {
    super()

    this.state = {
      activeSidebar: false,
      activeSubmenu: null,
      pageOffsetTop: 0,
      pageOffsetBottom: 0,
      topSticky: false,
      bottomSticky: false,
      topPosition: 0,
      bottomPosition: 0,
      pagePosition: 0,
      scrollUp: false,
      scrollDown: false,
      sidebarFixed: null,
      largeScreen: false
    }

    this.toggleSubmenu = this.toggleSubmenu.bind(this)
    this.toggleSubmenuByKey = this.toggleSubmenuByKey.bind(this)
    this.toggleSidebar = this.toggleSidebar.bind(this)
    this.toggleSidebarByKey = this.toggleSidebarByKey.bind(this)
  }

  componentDidMount () {
    if (this.props.sticky === true) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = (e) => {
    const offsetTopPosition = document.querySelector('.page').offsetTop
    const offsetBottomPosition = document.querySelector('.footer').offsetTop
    const sidebarHeight = document.querySelector('.sidebar').offsetHeight + 40
    const widowHeight = this.state.largeScreen && !this.state.scrollUp ? sidebarHeight - window.innerHeight : 0

    if (window.pageYOffset < this.state.pagePosition) {
      this.scrollUp()
    } else if (window.pageYOffset > this.state.pagePosition) {
      this.scrollDown()
    }

    this.setState({
      pageOffsetTop: offsetTopPosition,
      pageOffsetBottom: offsetBottomPosition,
      topSticky: window.pageYOffset >= (this.state.pageOffsetTop + widowHeight),
      bottomSticky: (window.pageYOffset + sidebarHeight - widowHeight) >= this.state.pageOffsetBottom,
      pagePosition: window.pageYOffset,
      largeScreen: sidebarHeight > window.innerHeight
    })
  }

  scrollUp = (e) => {
    this.setState({
      scrollUp: true,
      scrollDown: false
    })
  }

  scrollDown = (e) => {
    this.setState({
      scrollUp: false,
      scrollDown: true
    })
  }

  toggleSidebar () {
    const status = this.state.activeSidebar
    this.setState({
      activeSidebar: !status
    })

    this.toggle.setAttribute('aria-expanded', !status)
  }

  toggleSidebarByKey (e) {
    if (e.keyCode === 13) {
      this.toggleSidebar()
    }
  }

  toggleSubmenu (e, id) {
    const { activeSubmenu } = this.state
    if (activeSubmenu === id) {
      this.setState({ activeSubmenu: null })
      e.target.setAttribute('aria-expanded', false)
    } else {
      this.setState({ activeSubmenu: id })
      e.target.setAttribute('aria-expanded', true)
    }
  }

  toggleSubmenuByKey (e, id) {
    if (e.keyCode === 13) {
      this.toggleSubmenu(e, id)
    }
  }

  componentWillReceiveProps (newProps) {
    if (newProps.loading && this.state.activeSidebar) this.toggleSidebar()
  }

  render () {
    const { activePage, links } = this.props
    const { activeSidebar, activeSubmenu, topSticky, bottomSticky, sidebarFixed, scrollDown, largeScreen } = this.state

    if (!links) return null

    const Navigation = links.map((link, index) => {
      if (link.parent !== 0) return null

      const childLinks = links.filter((child) => child.parent === link.id)

      if (childLinks.length) {
        let submenuToggled, parentToggled
        if (activeSubmenu === link.id) {
          submenuToggled = 'sidebar-submenu--toggled'
          parentToggled = 'sidebar-parent--toggled'
        } else {
          submenuToggled = parentToggled = ''
        }

        const activeChild = childLinks.some((child) => child.link === activePage) ? 'sidebar-parent--active-child' : ''

        return (
          <li className={`sidebar-parent ${parentToggled} ${activeChild} sidebar__item`} key={index}>
            <span
              className={`sidebar__link`}
              onClick={(e) => this.toggleSubmenu(e, link.id)}
              onKeyDown={(e) => this.toggleSubmenuByKey(e, link.id)}
              aria-haspopup='true'
              aria-expanded='false'
              role='button'
              tabIndex='0'>
              { link.title }
              <ChevronIcon width='20px' height='20px' dir='right' className='svg-chevron' />
            </span>
            <ul className={`sidebar-submenu ${submenuToggled}`}>
              {
                childLinks.map((child, index) => {
                  const active = child.link === activePage ? 'sidebar__item--active' : ''

                  return (
                    <li className={`sidebar__item ${active} sidebar-submenu__item`} key={index}>
                      <HelpLink className='sidebar__link' href={child.link} data-test={'sidebar__link--' + index}>
                        { child.title }
                      </HelpLink>
                    </li>
                  )
                })
              }
            </ul>
          </li>
        )
      } else {
        const active = link.link === activePage ? 'sidebar__item--active' : ''

        return (
          <li className={`sidebar__item ${active}`} key={index}>
            <HelpLink className='sidebar__link' href={link.link} data-test={'sidebar__link--' + index}>
              { link.title }
            </HelpLink>
          </li>
        )
      }
    })

    const toggleStatus = activeSidebar ? ' sidebar-toggle--toggled' : ''
    const toggled = activeSidebar ? ' sidebar--toggled' : ''

    const topStickyClass = topSticky && !bottomSticky ? ' sidebar--sticky-top' : ''
    const topStickyFixedClass = topSticky && scrollDown === true && !bottomSticky && largeScreen === true ? ' sidebar--sticky-bottom--fixed' : ''
    const bottomStickyClass = bottomSticky === true ? ' sidebar--sticky-bottom' : ''

    return (
      <div className={'sidebar-container xs-12 lg-3' + topStickyClass + topStickyFixedClass + bottomStickyClass} style={sidebarFixed}>
        <nav className='help-menu' aria-labelledby='helpmenutoggle'>
          <div
            id='helpmenutoggle'
            className={`sidebar-toggle ${toggleStatus}`}
            onClick={this.toggleSidebar}
            onKeyDown={this.toggleSidebarByKey}
            aria-haspopup='true'
            aria-expanded='false'
            role='button'
            tabIndex='0'
            ref={(toggle) => { this.toggle = toggle }}>
            Help Menu
            <ChevronIcon width='20px' height='20px' className='svg-chevron' />
          </div>
          <ul className={`sidebar ${toggled} sidebar--purple`}>
            { Navigation }
          </ul>
        </nav>
      </div>
    )
  }
}
